import classNames from 'classnames';
import type { HTMLAttributes } from 'react';

import styles from './RadioIndicator.module.css';

export type RadioIndicatorCssVar = '--radio-background';

interface RadioIndicatorProps extends HTMLAttributes<HTMLSpanElement> {
  checked?: boolean;
  disabled?: boolean;
  isHovered?: boolean;
  isFocused?: boolean;
  cssVars?: Partial<Record<RadioIndicatorCssVar, string>>;
}

export const RadioIndicator = ({
  checked = false,
  disabled = false,
  isHovered = false,
  isFocused = false,
  className,
  cssVars,
  style,
  ...rest
}: RadioIndicatorProps) => {
  return (
    <span
      className={classNames([
        className,
        styles.indicator,
        checked && styles.checked,
        disabled && styles.disabled,
        isHovered && styles.hovered,
        isFocused && styles.focused,
      ])}
      style={cssVars ? { ...cssVars, ...style } : style}
      aria-hidden="true"
      data-radio-indicator
      data-checked={checked ? 'true' : undefined}
      {...rest}
    />
  );
};
